import axios from 'axios';
import { getToken } from './ServicioManejadorToken';
import { BASE_URL, ROOT_PATH } from './Constantes';
import { ServicioObjetos } from './ServicioObjetos';
var instanciaAxios = axios.create({
  baseURL: BASE_URL
});

instanciaAxios.interceptors.request.use(function (config) {
  return getToken(config).then(response => {
    let token = response;
    if (token) {
      if (config.method !== 'OPTIONS') {
        let autorizacion = token;
        config.headers.Authorization = autorizacion;
      }
    }
    document.body.classList.add('loading-indicator');
    return Promise.resolve(config);
  })
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return Promise.reject(error);
});

instanciaAxios.interceptors.response.use(function (response) {
  document.body.classList.remove('loading-indicator');
  return response;
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return getToken().then(response => {
    if (ServicioObjetos.esObjetoVacio(response)) {
      if (error.config.url.includes('autenticar?usuario=')) {
        return Promise.reject(error);
      }
      else {
        window.location = ROOT_PATH;
      }
    } else {
      return Promise.reject(error);
    }
  });
});

export default instanciaAxios;